<h1 mat-dialog-title>
  <mat-icon inline class="valign-bottom">info</mat-icon>
  {{ "EXTERNAL_NAVIGATION.DIALOG.TITLE" | translate }}
</h1>
<mat-dialog-content>
  <p>{{ "EXTERNAL_NAVIGATION.DIALOG.CONTENT" | translate: { href: data.url, name: data.name } }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton="outlined" [mat-dialog-close]>
    {{ "EXTERNAL_NAVIGATION.DIALOG.CANCEL" | translate }}
  </button>
  &nbsp;
  <a mat-flat-button [mat-dialog-close]="true" [href]="data.url" target="_blank" data-external-link="true">
    <mat-icon>open_in_new</mat-icon>
    {{ "EXTERNAL_NAVIGATION.DIALOG.OK" | translate }}
  </a>
</mat-dialog-actions>
